import { Navbar, Footer } from './LandingPage';
import { WanderfulHero } from './WanderfulHero';
import { ArrowRight, FileText, Download, MessageSquare } from 'lucide-react';

const ResourcesPage = () => {
  const resources = [
    {
      title: "Caught Teacher Errors",
      description: "An anonymized case study on how Parakh AI identified over 200 grading errors in a batch of 5,000 sheets previously marked by teachers.",
      icon: <MessageSquare className="w-8 h-8" />,
      link: "/resources/case-study",
      cta: "Read Case Study",
      color: "bg-blue-50 text-blue-600"
    },
    // {
    //   title: "Blog & SEO Hub",
    //   description: "Insights into the future of AI in education, evaluation trends, and tips for teachers to reduce workload.",
    //   icon: <BookOpen className="w-8 h-8" />,
    //   link: "/resources/blog",
    //   cta: "Explore Blog",
    //   color: "bg-purple-50 text-purple-600"
    // },
    {
      title: "Sample Evaluated Reports",
      description: "Download sample PDF and Excel reports generated by Parakh AI to see the depth of analytics we provide.",
      icon: <FileText className="w-8 h-8" />,
      link: "/resources/sample-reports",
      cta: "View Samples",
      color: "bg-green-50 text-green-600"
    },
    {
      title: "Free Rubric Templates",
      description: "Download free, industry-standard rubric templates for UPSC, JEE, and Board exams to standardize your marking.",
      icon: <Download className="w-8 h-8" />,
      link: "/resources/rubric-templates",
      cta: "Download Templates",
      color: "bg-orange-50 text-orange-600"
    }
  ];

  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <WanderfulHero 
        title="Everything you need to master evaluation."
        subtitle="Explore our library of case studies, templates, and insights designed for modern educators."
        cta1Text="Explore Now"
      />

      <section className="py-8 sm:py-12 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <span className="text-sm font-bold text-slate-900 uppercase tracking-widest bg-gray-100 px-4 py-1.5 rounded-full">Knowledge Hub</span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black mt-4">Resources</h2>
            <p className="text-gray-600 max-w-2xl mx-auto mt-4 font-medium">Tools and insights to help you transform your evaluation workflow.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
            {resources.map((res, index) => (
              <div
                key={index}
                className="group bg-[#f9f9f9] rounded-2xl sm:rounded-[24px] md:rounded-[40px] p-4 sm:p-6 md:p-8 lg:p-12 border border-transparent hover:border-black/5 hover:bg-white hover:shadow-2xl transition-all duration-500 flex flex-col justify-between cursor-pointer"
                onClick={() => window.location.href = res.link}
              >
                <div>
                  <div className={`w-16 h-16 rounded-2xl ${res.color} flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500`}>
                    {res.icon}
                  </div>
                  <h3 className="text-2xl font-bold text-black mb-4">{res.title}</h3>
                  <p className="text-gray-600 leading-relaxed mb-8">{res.description}</p>
                </div>
                
                <div className="flex items-center gap-2 font-bold text-black group-hover:gap-4 transition-all">
                  {res.cta} <ArrowRight className="w-5 h-5" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Resource / Lead Magnet Section */}
      <section className="pb-8 sm:pb-12 md:pb-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="bg-black text-white rounded-2xl sm:rounded-[24px] md:rounded-[40px] p-4 sm:p-6 md:p-8 lg:p-16 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-white/5 to-transparent pointer-events-none" />
            <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
              <div>
                <span className="text-sm font-bold text-white/50 uppercase tracking-widest">Featured Resource</span>
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-4 mb-6">Master the UPSC Rubric</h2>
                <p className="text-white/70 mb-8 text-lg leading-relaxed">
                  Download our comprehensive guide on how AI evaluates UPSC Mains answer sheets and how you can use these rubrics to train your students better.
                </p>
                <button 
                  onClick={() => window.location.href = "/resources/rubric-templates"}
                  className="bg-white text-black font-bold px-8 py-4 rounded-full hover:scale-105 transition-all flex items-center gap-2"
                >
                  Download Free Guide <Download className="w-4 h-4" />
                </button>
              </div>
              <div className="hidden lg:block relative">
                <div className="aspect-[4/3] bg-neutral-900 rounded-2xl border border-white/10 p-6 flex items-center justify-center">
                   <div className="text-center">
                     <FileText className="w-20 h-20 text-white/20 mx-auto mb-4" />
                     <p className="text-white/40 font-mono text-xs uppercase tracking-widest">UPSC_RUBRIC_V2.PDF</p>
                   </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ResourcesPage;
